import Vue from "vue";
import Router from "vue-router";
import JwtService from "@/services/JwtService";
import {route} from "@/constants";

const token = JwtService.getToken();

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: {name: token === null ? 'covers' : token.user.homePage},
            component: () => import("@/components/Layout"),
            children: [
                {
                    path: "/covers",
                    name: route.COVERS,
                    component: () => import("@/components/Covers")
                },
                {
                    path: "/list",
                    name: route.LIST,
                    component: () => import("@/components/List")
                }
            ]
        },
        {
            path: "/disclaimer",
            name: route.DISCLAIMER,
            component: () => import("@/components/Disclaimer"),
        },
        {
            path: "/error",
            name: route.ERROR,
            component: () => import("@/components/Error"),
        }
    ]
});
